/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: "TradeInput",
  data: function data() {
    return {};
  },
  props: {
    id: {
      default: ""
    },
    value: {
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: "left"
    }
  },
  watch: {
    value: {
      handler: function handler() {
        this.$forceUpdate();
      },
      immediate: true
    }
  },
  methods: {
    inputEvent: function inputEvent(e) {
      this.$emit("input", e);
    },
    keyupEvent: function keyupEvent(e) {
      this.$emit("keyup", e);
    },
    focusEvent: function focusEvent(e) {
      this.$emit("focus", e);
    },
    blurEvent: function blurEvent(e) {
      this.$emit("blur", e);
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "trade-input" },
    [
      _vm._t("left"),
      _vm._v(" "),
      _vm.id
        ? _c("input", {
            staticClass: "text-style-body-600",
            style: { "text-align": _vm.direction },
            attrs: {
              id: _vm.id,
              placeholder: _vm.placeholder,
              autocomplete: "off",
              inputmode: "decimal",
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.inputEvent,
              keyup: _vm.keyupEvent,
              focus: _vm.focusEvent,
              blur: _vm.blurEvent,
            },
          })
        : _c("input", {
            staticClass: "text-style-body-600",
            style: { "text-align": _vm.direction },
            attrs: {
              placeholder: _vm.placeholder,
              autocomplete: "off",
              inputmode: "decimal",
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.inputEvent,
              keyup: _vm.keyupEvent,
              focus: _vm.focusEvent,
              blur: _vm.blurEvent,
            },
          }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-20d84e01";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
